<template>
    <div>
        <h5 class="text-h5">
            {{ resultCategory.description() }}
            <inertia-link :href="`/result-categories/${resultCategory.id}`">
                <v-icon>mdi-open-in-new</v-icon>
            </inertia-link>
        </h5>

        <v-tabs v-model="tab">
            <v-tab href="#prelims">Qualification</v-tab>
            <v-tab v-if="hadRound('semi_final')" href="#finals">Q2</v-tab>
            <v-tab v-if="hadRound('finals')" href="#finals">Finals</v-tab>
            <v-tab v-if="hadRound('final_one')" href="#final_one">Final One</v-tab>
            <v-tab v-if="hadRound('final_two')" href="#final_two">Final Two</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item value="prelims">
                <template #default>
                    <full-results-table
                        :result-category="resultCategory"
                        :results="resultsForRound('prelims')"
                        :meet-id="meetId"
                        round="prelims"
                    />
                </template>
            </v-tab-item>

            <v-tab-item value="semi_final">
                <template #default>
                    <full-results-table
                        :result-category="resultCategory"
                        :results="resultsForRound('semi_final')"
                        :meet-id="meetId"
                        round="semi_final"
                    />
                </template>
            </v-tab-item>

            <v-tab-item value="finals">
                <template #default>
                    <full-results-table
                        :result-category="resultCategory"
                        :results="resultsForRound('finals')"
                        :meet-id="meetId"
                        round="finals"
                    />
                </template>
            </v-tab-item>

            <v-tab-item value="final_one">
                <template #default>
                    <full-results-table
                        :result-category="resultCategory"
                        :results="resultsForRound('final_one')"
                        :meet-id="meetId"
                        round="final_one"
                    />
                </template>
            </v-tab-item>

            <v-tab-item value="final_two">
                <template #default>
                    <full-results-table
                        :result-category="resultCategory"
                        :results="resultsForRound('final_two')"
                        :meet-id="meetId"
                        round="final_two"
                    />
                </template>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
import ResultCategory from '@/Models/ResultCategory.js';
import FullResultsTable from '@/Components/FullResults/FullResultsTable.vue';

export default {
    name: 'FullResultsTabs',

    components: { FullResultsTable },

    props: {
        resultCategory: {
            type: ResultCategory,
            required: true,
        },

        meetId: {
            type: Number,
            required: true,
        },

        results: {
            type: Array,
            required: true,
        },
    },

    data: () => ({
        tab: 'prelims',
    }),

    computed: {},

    created() {
        if (this.hadRound('final_two')) {
            this.tab = 'final_two';
        } else if (this.hadRound('final_one')) {
            this.tab = 'final_one';
        } else if (this.hadRound('finals')) {
            this.tab = 'finals';
        } else if (this.hadRound('semi_final')) {
            this.tab = 'semi_final';
        }
    },

    methods: {
        resultsForRound(round) {
            return this.results
                .filter(result => {
                    return result.category_id === this.resultCategory.id && result[`${round}_score`] !== null;
                })
                .sort((a, b) => {
                    return a[`${round}_rank`] - b[`${round}_rank`];
                });
            // return Result.query()
            //     .with(['athlete', 'club', 'athlete2', 'club2'])
            //     .with(this.scores, query => {
            //         query.where('round', round)
            //     })
            //     .where('meet_id', this.meetId)
            //     .where('category_id', this.resultCategory.id)
            //     .where(result => {
            //         return result[`${round}_score`] !== null;
            //     })
            //     .orderBy(`${round}_rank`)
            //     .get();
        },

        hadRound(round) {
            return this.resultsForRound(round).some(result => result[`${round}_score`]);
        },
    },
};
</script>
